import { render, staticRenderFns } from "./activityStudyMaterial.html?vue&type=template&id=4f2132af&external"
import script from "./activityStudyMaterial.vue?vue&type=script&lang=js"
export * from "./activityStudyMaterial.vue?vue&type=script&lang=js"
import style0 from "./activityStudyMaterial.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports